document.addEventListener('DOMContentLoaded', () => {
  // Mega Menu Left-to-Right Hover System
  const leftItems = document.querySelectorAll('.mega-left-item');
  const rightPanels = document.querySelectorAll('.mega-right-panel');

  if (leftItems.length > 0) {
    leftItems[0].classList.add('active');
    if (rightPanels.length > 0) rightPanels[0].classList.add('active');
  }

  leftItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      leftItems.forEach(i => i.classList.remove('active'));
      rightPanels.forEach(p => p.classList.remove('active'));

      item.classList.add('active');
      const targetId = item.getAttribute('data-target');
      const targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });

  // Out of Stock Enquiry Modal Controller
  const modal = document.getElementById('enquiryModal');
  const closeBtn = document.querySelector('.close-modal');
  const enquiryBtns = document.querySelectorAll('.open-enquiry-modal');
  const productInput = document.getElementById('enquiryProductInput');
  const productNameLabel = document.getElementById('enquiryProductName');

  enquiryBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const prodName = btn.getAttribute('data-product');
      productNameLabel.textContent = prodName;
      productInput.value = prodName;
      modal.style.display = 'flex';
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }

  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });

  // Enquiry Form submission handling
  const enquiryForm = document.getElementById('enquiryForm');
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', (e) => {
      e.preventDefault();
      alert('Thank you! Your enquiry has been sent to Kryptonite Microsystems support team.');
      modal.style.display = 'none';
      enquiryForm.reset();
    });
  }
});